"use strict";

function _instanceof (left, right) {
    if (
        right != null &&
        typeof Symbol !== "undefined" &&
        right[Symbol.hasInstance]
    ) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

function _classCallCheck (instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties (target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass (Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

export var Interval =
    /*#__PURE__*/
    (function () {
        function Interval (properties, fn) {
            _classCallCheck(this, Interval);

            if (!fn) {
                throw Error("No function given to Interval.");
            }

            var settings = properties || {};
            var autostart =
                settings.autostart !== undefined ? settings.autostart : true;
            this.delay = settings.delay || 0;
            this.duration = settings.duration || 1000;
            this.fps = settings.fps || 60;
            this.loop = settings.loop || false;
            this.fn = fn;

            if (autostart) {
                this.start();
            }
        }

        _createClass(Interval, [
            {
                key: "restart",
                value: function restart () {
                    this.stop();
                    this.start();
                    return this;
                }
            },
            {
                key: "start",
                value: function start () {
                    var _this = this;

                    if (this.interval) {
                        return this;
                    }

                    var startTime = Date.now() + this.delay;
                    var frameDuration = 1000 / this.fps;
                    var step = frameDuration / this.duration;
                    var position = 0;
                    this.interval = setInterval(function () {
                        var now = Date.now();

                        if (startTime > now) {
                            return;
                        }

                        position = Math.min(position + step, 1);

                        _this.fn.call(_this, position);

                        if (position >= 1) {
                            if (_this.loop) {
                                _this.restart();
                            } else {
                                _this.stop();
                            }
                        }
                    }, frameDuration);
                    return this;
                }
            },
            {
                key: "stop",
                value: function stop () {
                    this.interval = clearInterval(this.interval);
                    return this;
                }
            }
        ]);

        return Interval;
    })();